<template>
    <div class="col-12 px-1">
      <h3>{{ $t('spreader_data.title') }}</h3>
      <div class="nopads">
          <ul
              class="nav nav-tabs routa-tabs"
              role="tablist"
          >
              <li class="nav-item">
                  <button
                      class="routa-tab"
                      :class="{ active: tabIndex === 0 }"
                      :style="linkTabClass(0)"
                      @click="tabIndex = 0"
                  >
                      {{ $t('spreader_data.title') }}
                  </button>
                 </li>
              <li class="nav-item">
                  <button
                      class="routa-tab"
                      :class="{ active: tabIndex === 1 }"
                      :style="linkTabClass(1)"
                      @click="tabIndex = 1"
                  >
                      {{ $t('spreader_data.restriction_areas') }}
                  </button>
              </li>
          </ul>
          <div class="tab-content routa-tab-content">
              <div v-show="tabIndex === 0" class="tab-pane fade show active"  style="min-height: 88vh">
                  <spreader-data :user="user"/>
              </div>
              <div v-show="tabIndex === 1" class="tab-pane fade show active" style="min-height: 88vh">
                  <spreader-restriction-areas/>
              </div>
          </div>
      </div>
  </div>
</template>


<script>
import Navbar from "../../utils/Navbar.vue";
import SpreaderData from "./SpreaderData.vue";
import SpreaderRestrictionAreas from "./SpreaderRestrictionAreas.vue";

export default {
    name: 'SpreaderDataTabbed',
    components: {
        SpreaderRestrictionAreas,
        SpreaderData,
        Navbar,
    },
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            tabIndex: 0
        }
    },

    methods: {
        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        }
    }

}
</script>
